<template>
  <div>
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        <v-autocomplete
          dense
          ref="autocomplete"
          v-model="select"
          :loading="loading"
          :items="all"
          item-value="id"
          @update:search-input="onSearchTextChange"
          :item-text="(item) => { return item.razon_social + ' | ' + item.documento }"
          :no-data-text="noDataText"
          placeholder="Busque una cuenta"
          flat
          full-width
          solo-inverted
          @keydown.enter="onMenuBuscar"
          @change="onSelect"
          no-filter
        >
      <template v-slot:no-data>
        <v-alert
          v-if="itemsLength == 0"
          dense
          color="warning"
          border="top"
          colored-border
          icon="mdi-alert"
        >
          No hay resultados para la búsqueda. Vuelva a intentar con otro texto
        </v-alert>
        <v-alert
          v-else
          dense
          color="info"
          border="top"
          colored-border
          icon="mdi-information"
        >
          Escriba más de 2 caracteres y presione Enter...
        </v-alert>
      </template>
      <template v-slot:prepend>
        <v-btn
          icon
          @click="onMenuBuscar"
          :disabled="!searchEnabled"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-subtitle><v-icon small left>mdi-card-account-details</v-icon>{{ data.item.documento }} <b>{{ data.item.razon_social }}</b></v-list-item-subtitle>
          <v-list-item-subtitle><v-icon small left>mdi-credit-card</v-icon>{{ data.item.numero }} {{ data.item.descripcion }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ClienteCreate from '@/pages/clientes/CreateComponent'
import PrecioMixin from '@/mixins/Precios'
export default {
  name: 'CuentaDestinoSelectComponent',
  mixins: [PrecioMixin],
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      select: null,
      dialogCreate: false,
    }
  },
  beforeMount () {
    // Agrega el event listener en el gancho beforeMount
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  async created () {
    this.$nextTick(() => {
      this.$refs.autocomplete.focus();
    });
  },
  computed: {
    ...mapGetters('CuentasDestinos', ['all', 'edited', 'selected', 'options', 'filters', 'loading', 'itemsLength']),
    ...mapGetters('Transferencias', { transferenciaEdited: 'edited' }),
    noDataText () {
      return 'Mínimo de caracteres tres (3). Luego, presione Enter...'
    },
    searchText: {
      get () {
        return this.filters.searchText
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          searchText: value
        })
      }
    },
    searchEnabled () {
      return this.searchText && this.searchText.length > 2
    }
  },
  methods: {
    ...mapActions('CuentasDestinos', ['onFetch', 'onClearAll']),
    ...mapMutations('CuentasDestinos', ['setSelected', 'setFilters']),
    ...mapMutations('Transferencias', { setTransferenciaEdited: 'setEdited', setTransferenciaCuenta: 'setCuenta' }),
    onSearchTextChange (val) {
      // console.log(val)
      this.searchText = val;
    },
    onMenuBuscar (event) {
      event.preventDefault()
      if (this.searchEnabled) this.onFetch()
      else alert('Debe escribir algo para buscar!')
    },
    onFocusCuenta (event) {
      event.preventDefault()
      this.$nextTick(() => {
        this.$refs.autocomplete.focus();
      });
    },
    onSelect (val) {
      const selectedItem = this.all.find(item => item.id === val);
      if (selectedItem) {
        const aux = {
          id: selectedItem.id,
          documento: selectedItem.documento,
          razon_social: selectedItem.razon_social,
          numero: selectedItem.numero,
          descripcion: selectedItem.descripcion,
          tolerancia: selectedItem.tolerancia,
          cierre: selectedItem.cierre,
          kilos_pleno: selectedItem.kilos_pleno,
          saldo_pleno: selectedItem.saldo_pleno,
          saldo_subsidio: selectedItem.saldo_subsidio,
          saldo_usuario: selectedItem.saldo_usuario,
          credito_demas: selectedItem.credito_demas,
          recalculado_at: selectedItem.recalculado_at,
          inactivo: selectedItem.inactivo,
          cliente_id: selectedItem.cliente_id,
          created_at: selectedItem.created_at,
          updated_at: selectedItem.updated_at,
        };
        this.setSelected(aux);
        this.searchText = selectedItem.razon_social;  // Esto mantiene el nombre visible

        // Actualizar store de Transferencias
        this.setTransferenciaEdited({
          ...this.transferenciaEdited,
          cuenta_destino_id: selectedItem.id,
        });
        // console.log('Transferencia actualizada - cuenta_destino_id:', selectedItem.id, 'Estado completo:', this.transferenciaEdited);
        this.setTransferenciaCuenta({
          id: selectedItem.id,
          documento: selectedItem.documento,
          razon_social: selectedItem.razon_social,
          numero: selectedItem.numero,
          descripcion: selectedItem.descripcion,
        });

        // Emitir evento para v-model
        this.$emit('input', selectedItem.id);

        this.onClearAll()
        // this.$root.$emit('update:saldo_id', selectedItem.id);//Se notifica la cuenta saldo
      }
    },
    onDialogCreate (event) {
      event.preventDefault()
      this.dialogCreate = true
    },
    handleKeyboard (event) {
      if(event.altKey && event.key == 'n') {
        this.onDialogCreate(event)
      }
    },
  },
  watch: {
    value (newValue) {
      // Sincronizar el prop value con el estado interno
      if (newValue !== this.select) {
        this.select = newValue;
      }
    },
    select (newValue) {
      if (newValue > 0) {
        const selectedItem = this.all.find(item => item.id === newValue);
        // console.log('Select changed:', newValue, selectedItem)
        if (selectedItem) {
          this.setSelected(selectedItem);
          this.searchText = selectedItem.razon_social; // Esto asegura que el nombre permanezca visible
        }
      }
    },
  },
}
</script>
